var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagramm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.825 0H19.175C21.84 0 24 2.19197 24 4.89641V19.1036C24 21.808 21.84 24 19.175 24H4.825C2.16 24 0 21.808 0 19.1036V4.89641C0 2.19197 2.16 0 4.825 0ZM6.35 12C6.35 15.1662 8.88 17.7336 12 17.7336C15.12 17.7336 17.65 15.1662 17.65 12C17.65 8.83383 15.12 6.26638 12 6.26638C8.88 6.26638 6.35 8.83383 6.35 12ZM19.2613 6.46663C20.3395 6.46663 21.2135 5.59259 21.2135 4.51441C21.2135 3.43623 20.3395 2.5622 19.2613 2.5622C18.1831 2.5622 17.3091 3.43623 17.3091 4.51441C17.3091 5.59259 18.1831 6.46663 19.2613 6.46663Z",
    fill: ""
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramm);
export default __webpack_public_path__ + "static/media/instagramm.17e9bcf607d96327b5a0d9cbd05275a0.svg";
export { ForwardRef as ReactComponent };